import React, { useRef, useEffect } from "react";
import { postEndpoint, GetHook, putEndpoint } from "../../../api/api";
import { useParams } from "react-router-dom";
import { DropDownOptionsProps, DropDown } from "../../../ui/DropDown";
import { StatusIcon } from "../../../assets/svg/StatusIcon";
import { PERSPECTIVE_URL, SCORECARD_URL } from "../../../api/urls";
import { parseDropdown } from "../../../utils/parseDropdown";
import { Formik, Field } from "formik";
import Form, { InputSection } from "../components/Form";
import { get } from "../../../utils/get";
import Input from "../../../ui/Input";
import { toast } from "react-toastify";
import { PerspectiveSchema } from "../../../utils/validationSchema/ScorecardSchema/ScorecardValidation";

interface Iprops {
  setHandleSubmit?: any;
  setPerspectives?: any;
  perspective?: any;
  closeModal?: any;
  editData?: any;
}

const AddPerspective = ({
  setHandleSubmit,
  setPerspectives,
  perspective,
  closeModal,
  editData,
}: Iprops) => {
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const { id } = useParams();
  const formRef: any = useRef<any>(null);

  const { perspective_id: editId } = editData;
  const isAddMode = !editId;

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  const { data: perspectives } = GetHook(PERSPECTIVE_URL);

  useEffect(() => {
    if (!isAddMode) {
      const fields = ["perspective", "weight", "notes"];

      const newEditData = {
        ...editData,
        perspective: {
          value: get(editData, "perspective.id"),
          label: get(editData, "perspective.name"),
        },
      };
    
      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
    }
  }, [isAddMode]);

  const handleAddPerspective = (values) => {
    const payload = {
      perspective_id: get(values, "perspective.value"),
      weight: get(values, "weight"),
      notes: get(values, "notes"),
    };

    createReq(`${SCORECARD_URL}/${id}/perspective`, payload);
  };

  const editProspective = (values) => {
    const payload = {
      weight: get(values, "weight"),
      notes: get(values, "notes"),
    };
    updateReq(
      `${SCORECARD_URL}/${id}/perspective/${editData.perspective_id}`,
      payload
    );
  };

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      closeModal();
      toast.success("Perspetive added successfully");
    }

    return () => {};
  }, [createRes]);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      toast.success("Perspetive updated successfully");
      closeModal();
    }
  }, [closeModal, updateRes]);

  const perspectiveOptions = parseDropdown(perspectives);
  const initialValues = {
    perspective: "",
    weight: "",
    notes: "",
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={PerspectiveSchema}
      onSubmit={
        isAddMode ? (values) => handleAddPerspective(values) : editProspective
      }
    >
      {() => (
        <Form>
          <InputSection>
            <Field
              name="perspective"
              placeholder="select perspective name"
              dropdownLabel="Perspective name"
              component={DropDown}
              isBordered={true}
              options={perspectiveOptions}
              width="96%"
            />
          </InputSection>

          <Field
            type="text"
            name="weight"
            component={Input}
            placeholder="enter weight"
            label="Weignt"
            isBordered={true}
            width="18em"
          />

          <InputSection>
            <Field
              type="textarea"
              name="notes"
              placeholder="Description"
              label="Perspective description"
              component={Input}
            />
          </InputSection>
        </Form>
      )}
    </Formik>
  );
};

export default AddPerspective;
